module.exports = __webpack_public_path__ + "94c6ab5cf7259227f3096b97780549df.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/fragolina.png
// module id = 600
// module chunks = 0